import { render } from "./MultipleAttach.vue?vue&type=template&id=03931681"
import script from "./MultipleAttach.vue?vue&type=script&lang=js"
export * from "./MultipleAttach.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__